"use client";

import { NoResultsDisplayProps } from "./types";

export const NoResultsDisplay = ({ isEscuela }: NoResultsDisplayProps) => {
  return (
    <div className="col-span-full flex flex-col justify-center items-center min-h-[400px] w-full px-4">
      <div className="text-center py-16 bg-white rounded-xl shadow-sm border border-gray-100 max-w-lg w-full">
        <div className="flex flex-col items-center justify-center">
          <div className="bg-blue-50 p-4 rounded-full mb-4">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <h3 className="text-xl font-semibold text-gray-800 mb-2">
            No se encontraron resultados
          </h3>
          <p className="text-gray-500 max-w-md mb-6">
            No hay {isEscuela ? "escuelas" : "instructores"} disponibles con los filtros seleccionados. Por favor, prueba con otros filtros.
          </p>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
          >
            Modificar filtros
          </button>
        </div>
      </div>
    </div>
  );
}; 